/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Stronger Memory API
 * Lean companion API. OnEarly Core is the system of record.
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ErrorResponse,
  GroupProgressParams,
  GroupProgressResponse,
  HealthResponse,
  MarkOutcome,
  ReadyResponse,
  StatusResponse,
} from './models';

import { echoRequest } from '../../client';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type metaHealthResponse200 = {
  data: HealthResponse;
  status: 200;
};

export type metaHealthResponseSuccess = metaHealthResponse200 & {
  headers: Headers;
};

export type metaHealthResponse = metaHealthResponseSuccess;

export const getMetaHealthUrl = () => {
  return `/health`;
};

export const metaHealth = async (
  options?: Parameters<typeof echoRequest>[1],
): Promise<metaHealthResponse> => {
  return echoRequest<metaHealthResponse>(getMetaHealthUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getMetaHealthQueryKey = () => {
  return [`/health`] as const;
};

export const getMetaHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof metaHealth>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metaHealth>>, TError, TData>>;
  request?: SecondParameter<typeof echoRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMetaHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof metaHealth>>> = ({ signal }) =>
    metaHealth({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof metaHealth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MetaHealthQueryResult = NonNullable<Awaited<ReturnType<typeof metaHealth>>>;
export type MetaHealthQueryError = unknown;

export function useMetaHealth<TData = Awaited<ReturnType<typeof metaHealth>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof metaHealth>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metaHealth>>,
          TError,
          Awaited<ReturnType<typeof metaHealth>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMetaHealth<TData = Awaited<ReturnType<typeof metaHealth>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metaHealth>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metaHealth>>,
          TError,
          Awaited<ReturnType<typeof metaHealth>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMetaHealth<TData = Awaited<ReturnType<typeof metaHealth>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metaHealth>>, TError, TData>>;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useMetaHealth<TData = Awaited<ReturnType<typeof metaHealth>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metaHealth>>, TError, TData>>;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMetaHealthQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type metaReadyResponse200 = {
  data: ReadyResponse;
  status: 200;
};

export type metaReadyResponse503 = {
  data: ReadyResponse;
  status: 503;
};

export type metaReadyResponseSuccess = metaReadyResponse200 & {
  headers: Headers;
};
export type metaReadyResponseError = metaReadyResponse503 & {
  headers: Headers;
};

export type metaReadyResponse = metaReadyResponseSuccess | metaReadyResponseError;

export const getMetaReadyUrl = () => {
  return `/ready`;
};

export const metaReady = async (
  options?: Parameters<typeof echoRequest>[1],
): Promise<metaReadyResponse> => {
  return echoRequest<metaReadyResponse>(getMetaReadyUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getMetaReadyQueryKey = () => {
  return [`/ready`] as const;
};

export const getMetaReadyQueryOptions = <
  TData = Awaited<ReturnType<typeof metaReady>>,
  TError = ReadyResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metaReady>>, TError, TData>>;
  request?: SecondParameter<typeof echoRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMetaReadyQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof metaReady>>> = ({ signal }) =>
    metaReady({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof metaReady>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MetaReadyQueryResult = NonNullable<Awaited<ReturnType<typeof metaReady>>>;
export type MetaReadyQueryError = ReadyResponse;

export function useMetaReady<TData = Awaited<ReturnType<typeof metaReady>>, TError = ReadyResponse>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof metaReady>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metaReady>>,
          TError,
          Awaited<ReturnType<typeof metaReady>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMetaReady<TData = Awaited<ReturnType<typeof metaReady>>, TError = ReadyResponse>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metaReady>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metaReady>>,
          TError,
          Awaited<ReturnType<typeof metaReady>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMetaReady<TData = Awaited<ReturnType<typeof metaReady>>, TError = ReadyResponse>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metaReady>>, TError, TData>>;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useMetaReady<TData = Awaited<ReturnType<typeof metaReady>>, TError = ReadyResponse>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metaReady>>, TError, TData>>;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMetaReadyQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type metaStatusResponse200 = {
  data: StatusResponse;
  status: 200;
};

export type metaStatusResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type metaStatusResponseSuccess = metaStatusResponse200 & {
  headers: Headers;
};
export type metaStatusResponseError = metaStatusResponse401 & {
  headers: Headers;
};

export type metaStatusResponse = metaStatusResponseSuccess | metaStatusResponseError;

export const getMetaStatusUrl = () => {
  return `/v1/status`;
};

export const metaStatus = async (
  options?: Parameters<typeof echoRequest>[1],
): Promise<metaStatusResponse> => {
  return echoRequest<metaStatusResponse>(getMetaStatusUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getMetaStatusQueryKey = () => {
  return [`/v1/status`] as const;
};

export const getMetaStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof metaStatus>>,
  TError = ErrorResponse,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metaStatus>>, TError, TData>>;
  request?: SecondParameter<typeof echoRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMetaStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof metaStatus>>> = ({ signal }) =>
    metaStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof metaStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MetaStatusQueryResult = NonNullable<Awaited<ReturnType<typeof metaStatus>>>;
export type MetaStatusQueryError = ErrorResponse;

export function useMetaStatus<
  TData = Awaited<ReturnType<typeof metaStatus>>,
  TError = ErrorResponse,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof metaStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metaStatus>>,
          TError,
          Awaited<ReturnType<typeof metaStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMetaStatus<
  TData = Awaited<ReturnType<typeof metaStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metaStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metaStatus>>,
          TError,
          Awaited<ReturnType<typeof metaStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMetaStatus<
  TData = Awaited<ReturnType<typeof metaStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metaStatus>>, TError, TData>>;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useMetaStatus<
  TData = Awaited<ReturnType<typeof metaStatus>>,
  TError = ErrorResponse,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metaStatus>>, TError, TData>>;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMetaStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type groupProgressResponse200 = {
  data: GroupProgressResponse;
  status: 200;
};

export type groupProgressResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type groupProgressResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type groupProgressResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type groupProgressResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type groupProgressResponse502 = {
  data: ErrorResponse;
  status: 502;
};

export type groupProgressResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type groupProgressResponseSuccess = groupProgressResponse200 & {
  headers: Headers;
};
export type groupProgressResponseError = (
  | groupProgressResponse400
  | groupProgressResponse401
  | groupProgressResponse403
  | groupProgressResponse404
  | groupProgressResponse502
  | groupProgressResponse503
) & {
  headers: Headers;
};

export type groupProgressResponse = groupProgressResponseSuccess | groupProgressResponseError;

export const getGroupProgressUrl = (groupActorUuid: string, params: GroupProgressParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/v1/groups/${groupActorUuid}/progress?${stringifiedParams}`
    : `/v1/groups/${groupActorUuid}/progress`;
};

/**
 * Completion only, never answers or timings: each day exercise by exercise, for everyone in the group. A leader of the group (Admin) also gets the marks made in this group, to undo one.
 * @summary Each member's week in one of the caller's Stronger Memory groups
 */
export const groupProgress = async (
  groupActorUuid: string,
  params: GroupProgressParams,
  options?: Parameters<typeof echoRequest>[1],
): Promise<groupProgressResponse> => {
  return echoRequest<groupProgressResponse>(getGroupProgressUrl(groupActorUuid, params), {
    ...options,
    method: 'GET',
  });
};

export const getGroupProgressQueryKey = (groupActorUuid: string, params?: GroupProgressParams) => {
  return [`/v1/groups/${groupActorUuid}/progress`, ...(params ? [params] : [])] as const;
};

export const getGroupProgressQueryOptions = <
  TData = Awaited<ReturnType<typeof groupProgress>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  params: GroupProgressParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof groupProgress>>, TError, TData>>;
    request?: SecondParameter<typeof echoRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGroupProgressQueryKey(groupActorUuid, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof groupProgress>>> = ({ signal }) =>
    groupProgress(groupActorUuid, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: groupActorUuid !== null && groupActorUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof groupProgress>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GroupProgressQueryResult = NonNullable<Awaited<ReturnType<typeof groupProgress>>>;
export type GroupProgressQueryError = ErrorResponse;

export function useGroupProgress<
  TData = Awaited<ReturnType<typeof groupProgress>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  params: GroupProgressParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof groupProgress>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof groupProgress>>,
          TError,
          Awaited<ReturnType<typeof groupProgress>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGroupProgress<
  TData = Awaited<ReturnType<typeof groupProgress>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  params: GroupProgressParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof groupProgress>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof groupProgress>>,
          TError,
          Awaited<ReturnType<typeof groupProgress>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGroupProgress<
  TData = Awaited<ReturnType<typeof groupProgress>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  params: GroupProgressParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof groupProgress>>, TError, TData>>;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Each member's week in one of the caller's Stronger Memory groups
 */

export function useGroupProgress<
  TData = Awaited<ReturnType<typeof groupProgress>>,
  TError = ErrorResponse,
>(
  groupActorUuid: string,
  params: GroupProgressParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof groupProgress>>, TError, TData>>;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGroupProgressQueryOptions(groupActorUuid, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type markExerciseDoneResponse200 = {
  data: MarkOutcome;
  status: 200;
};

export type markExerciseDoneResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type markExerciseDoneResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type markExerciseDoneResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type markExerciseDoneResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type markExerciseDoneResponse502 = {
  data: ErrorResponse;
  status: 502;
};

export type markExerciseDoneResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type markExerciseDoneResponseSuccess = markExerciseDoneResponse200 & {
  headers: Headers;
};
export type markExerciseDoneResponseError = (
  | markExerciseDoneResponse400
  | markExerciseDoneResponse401
  | markExerciseDoneResponse403
  | markExerciseDoneResponse404
  | markExerciseDoneResponse502
  | markExerciseDoneResponse503
) & {
  headers: Headers;
};

export type markExerciseDoneResponse =
  | markExerciseDoneResponseSuccess
  | markExerciseDoneResponseError;

export const getMarkExerciseDoneUrl = (
  groupActorUuid: string,
  memberActorUuid: string,
  date: string,
  kind: 'read' | 'write' | 'math',
) => {
  return `/v1/groups/${groupActorUuid}/members/${memberActorUuid}/marks/${date}/${kind}`;
};

/**
 * @summary Mark a member's exercise done, as a leader of their group
 */
export const markExerciseDone = async (
  groupActorUuid: string,
  memberActorUuid: string,
  date: string,
  kind: 'read' | 'write' | 'math',
  options?: Parameters<typeof echoRequest>[1],
): Promise<markExerciseDoneResponse> => {
  return echoRequest<markExerciseDoneResponse>(
    getMarkExerciseDoneUrl(groupActorUuid, memberActorUuid, date, kind),
    {
      ...options,
      method: 'PUT',
    },
  );
};

export const getMarkExerciseDoneMutationKey = () => ['markExerciseDone'] as const;

export const getMarkExerciseDoneMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markExerciseDone>>,
    TError,
    MarkExerciseDoneMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof echoRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markExerciseDone>>,
  TError,
  MarkExerciseDoneMutationVariables,
  TContext
> => {
  const mutationKey = getMarkExerciseDoneMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markExerciseDone>>,
    MarkExerciseDoneMutationVariables
  > = (props) => {
    const { groupActorUuid, memberActorUuid, date, kind } = props ?? {};

    return markExerciseDone(groupActorUuid, memberActorUuid, date, kind, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkExerciseDoneMutationResult = NonNullable<
  Awaited<ReturnType<typeof markExerciseDone>>
>;

export type MarkExerciseDoneMutationError = ErrorResponse;
export type MarkExerciseDoneMutationVariables = {
  groupActorUuid: string;
  memberActorUuid: string;
  date: string;
  kind: 'read' | 'write' | 'math';
};

/**
 * @summary Mark a member's exercise done, as a leader of their group
 */
export const useMarkExerciseDone = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markExerciseDone>>,
      TError,
      MarkExerciseDoneMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markExerciseDone>>,
  TError,
  MarkExerciseDoneMutationVariables,
  TContext
> => {
  return useMutation(getMarkExerciseDoneMutationOptions(options), queryClient);
};

export type undoExerciseMarkResponse200 = {
  data: MarkOutcome;
  status: 200;
};

export type undoExerciseMarkResponse400 = {
  data: ErrorResponse;
  status: 400;
};

export type undoExerciseMarkResponse401 = {
  data: ErrorResponse;
  status: 401;
};

export type undoExerciseMarkResponse403 = {
  data: ErrorResponse;
  status: 403;
};

export type undoExerciseMarkResponse404 = {
  data: ErrorResponse;
  status: 404;
};

export type undoExerciseMarkResponse502 = {
  data: ErrorResponse;
  status: 502;
};

export type undoExerciseMarkResponse503 = {
  data: ErrorResponse;
  status: 503;
};

export type undoExerciseMarkResponseSuccess = undoExerciseMarkResponse200 & {
  headers: Headers;
};
export type undoExerciseMarkResponseError = (
  | undoExerciseMarkResponse400
  | undoExerciseMarkResponse401
  | undoExerciseMarkResponse403
  | undoExerciseMarkResponse404
  | undoExerciseMarkResponse502
  | undoExerciseMarkResponse503
) & {
  headers: Headers;
};

export type undoExerciseMarkResponse =
  | undoExerciseMarkResponseSuccess
  | undoExerciseMarkResponseError;

export const getUndoExerciseMarkUrl = (
  groupActorUuid: string,
  memberActorUuid: string,
  date: string,
  kind: 'read' | 'write' | 'math',
) => {
  return `/v1/groups/${groupActorUuid}/members/${memberActorUuid}/marks/${date}/${kind}`;
};

/**
 * Marks made in another group stay.
 * @summary Undo this group's marks of a member's exercise
 */
export const undoExerciseMark = async (
  groupActorUuid: string,
  memberActorUuid: string,
  date: string,
  kind: 'read' | 'write' | 'math',
  options?: Parameters<typeof echoRequest>[1],
): Promise<undoExerciseMarkResponse> => {
  return echoRequest<undoExerciseMarkResponse>(
    getUndoExerciseMarkUrl(groupActorUuid, memberActorUuid, date, kind),
    {
      ...options,
      method: 'DELETE',
    },
  );
};

export const getUndoExerciseMarkMutationKey = () => ['undoExerciseMark'] as const;

export const getUndoExerciseMarkMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof undoExerciseMark>>,
    TError,
    UndoExerciseMarkMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof echoRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof undoExerciseMark>>,
  TError,
  UndoExerciseMarkMutationVariables,
  TContext
> => {
  const mutationKey = getUndoExerciseMarkMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof undoExerciseMark>>,
    UndoExerciseMarkMutationVariables
  > = (props) => {
    const { groupActorUuid, memberActorUuid, date, kind } = props ?? {};

    return undoExerciseMark(groupActorUuid, memberActorUuid, date, kind, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UndoExerciseMarkMutationResult = NonNullable<
  Awaited<ReturnType<typeof undoExerciseMark>>
>;

export type UndoExerciseMarkMutationError = ErrorResponse;
export type UndoExerciseMarkMutationVariables = {
  groupActorUuid: string;
  memberActorUuid: string;
  date: string;
  kind: 'read' | 'write' | 'math';
};

/**
 * @summary Undo this group's marks of a member's exercise
 */
export const useUndoExerciseMark = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof undoExerciseMark>>,
      TError,
      UndoExerciseMarkMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof echoRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof undoExerciseMark>>,
  TError,
  UndoExerciseMarkMutationVariables,
  TContext
> => {
  return useMutation(getUndoExerciseMarkMutationOptions(options), queryClient);
};
